import { useFeatureFlagContext } from '@contexts/FeatureFlagContext';

/**
 * Hook that provides feature flag control functions
 * Use this when you need to modify feature flags (e.g., in admin panels or dev tools)
 *
 * @returns Object with all feature flag control functions
 */
export function useFeatureFlagControls() {
  const { setFeatureStatus, resetFeatureStatus, setAllFeaturesOn, setAllFeaturesOff, setAllFeaturesDefault } =
    useFeatureFlagContext();

  return {
    setFeatureStatus,
    resetFeatureStatus,
    setAllFeaturesOn,
    setAllFeaturesOff,
    setAllFeaturesDefault,
  };
}

export default useFeatureFlagControls;
